import React from "react";

import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const EndpointProtection = () => {
    const heading = `ENDPOINT PROTECTION`;
    const details = `Designed to guard your cloud against malicious activity.`;

    const overview = [
        `DETASAD’s Endpoint Protection offers advanced automated threat detection, along with rapid response against an ever-growing variety of threats.`
    ];

    const advantages = [
        [
            `All-round Protection`,
            `Defend against emerging threats such as ransomware and others with multilayered protection that fuses signatureless technologies like advanced machine learning, behavior analysis and exploit prevention with proven protection abilities like intrusion prevention, reputation analysis and more.`,
            icon
        ],
        [
            `Adjustable Policies`,
            `Achieve enhanced visibility into suspicious files via adjustable protection to make better policy decisions.`,
            icon
        ],
        [
            `Deception`,
            `Use deception techniques to expose hidden foes and determine their intent to improve security posture.`,
            icon
        ],
        [
            `Isolation of Malicious Activity`,
            `Protect commonly and frequently used applications against vulnerability exploits and isolate suspicious applications from malicious activity.`,
            icon
        ]
    ];

    const functions = [
        [
            `Lightweight Agent`,
            [
                `DETASAD ensures that the Endpoint Protection agent remains lightweight so that your resources can be better utilized for your business needs.`
            ]
        ],
        [
            `Anti-Malware`,
            [`Automatically detects Malware to ensure effective and efficient protection for your Cloud.`]
        ],
        [
            `Exploit Prevention`,
            [`Ensures that applications with malicious intent are not allowed to utilize any exploits in the system.`]
        ]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-security"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default EndpointProtection;
